<template>
  <div class="new-order new-notice-order">
    <div class="header">
      <span class="title">新增发货通知单</span>
      <div class="control-button">
        <el-button @click="close()">取消</el-button>
        <el-button type="primary" @click="draft">保存为草稿</el-button>
        <el-button type="primary" @click="checkValue" :disabled="submitDisable">提交</el-button>
      </div>
    </div>
    <div class="body">
      <div class="notice-base">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="基本信息">
            <el-form ref="form" inline>
              <qx-new-form-item :item="baseItemObj.deliveryTime">
                <template>
                  <el-date-picker v-model="dataObj.deliveryTime" type="date"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="deliveryTimePickerOptions"
                                  placeholder="请选择出库日期"/>
                </template>
              </qx-new-form-item>
              <el-form-item label="客户" required>
                <template>
                  <CustomerMassageAutoComplete :value.sync="customerData"
                                                :placeholder="'请选择客户联系人'"
                                                @setValue="setCustomer"
                                                @clear="clearCustomer"/>
                </template>
                <!-- <template>
                    <el-select
                      v-model="customerData"
                      filterable
                      remote
                      reserve-keyword
                      placeholder="请选择客户联系人"
                      :remote-method="customerRemoteMethod"
                      :loading="false"
                      style="width: 500px"
                      @change="customerChange">
                      <el-option
                        v-for="item in customerOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </template> -->
              </el-form-item>
              <el-form-item label="联系地址" required>
                <template>
                    <el-input ref="deliveryAddress"
                              v-model="deliveryAddress"
                              placeholder="请选择地址"
                              @focus="addressSelect('delivery')"
                              style="width: 500px"></el-input>
                </template>
              </el-form-item>
              <el-form-item label="账单地址">
                <template>
                  <el-switch
                    v-model="billIsShow"
                    active-color="#13ce66"
                    @change="billIsShowChange">
                  </el-switch>
                </template>
              </el-form-item>
              <el-form-item label="账单地址" v-if="billIsShow">
                <template>
                    <el-input ref="billAddress"
                              v-model="billAddress"
                              placeholder="请选择地址"
                              @focus="addressSelect('bill')"
                              style="width: 500px"></el-input>
                </template>
              </el-form-item>
              <el-form-item label="中转站">
                <el-switch
                    v-model="transferIsShow"
                    active-color="#13ce66"
                    @change="changeTransferInfo">
                </el-switch>
              </el-form-item>
              <el-form-item label="中转站" v-if="transferIsShow">
                <el-input placeholder="请输入中转站"
                        class="transferInfo_input"
                        size="small"
                        v-model="dataObj.transferInfo"></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <template>
                  <el-input placeholder="请输入备注"
                      :rows="1"
                      style="width: 500px"
                      type="textarea"
                      v-model.trim="dataObj.remark"/>
                </template>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件信息" name="附件信息">
            <el-form inline>
              <el-form-item label="附件上传">
                <file-upload-list :file-list.sync="saleFile"/>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-divider/>
        <span>物品明细</span>
        <qx-select-table :data="qxList.value.orderDetailsList">
          <el-table-column type="index" label="序号"/>
          <qx-select-table-column prop="saleOrderNo" label="销售订单编号" :disabled="true" width="200">
            <template v-slot:button>
              <el-button type="primary" @click="openOrderDialog" :disabled="orderBtnDisabled">
                选择订单
              </el-button>
            </template>
          </qx-select-table-column>
          <el-table-column prop="goodsNo" label="物品编号"/>
          <qx-select-table-column prop="noticeMainCount"
                                  label="本次通知发货主数量" :is-slot="true">
            <template v-slot="{scope}">
              <qx-input-number v-model="scope.row.noticeMainCount" :controls="false"
                               :precision="2"
                               @focus="onFocus($event)"
                               @blur="blurNoticeMainCount(scope.row, scope.$index)"
                               :ref="'noticeMainCount' + scope.$index"/>
            </template>
          </qx-select-table-column>
          <qx-select-table-column label="主单位" prop="noticeMainUnit" is-slot>
            <template v-slot="{scope}">
              <select-unit :unit-list="mainUnitList"
                           :default-id="scope.row.noticeMainUnitId"
                           :index="scope.$index"
                           :goods="scope.row"
                           v-on:setUnit="setMainUnit"/>
            </template>
          </qx-select-table-column>
          <qx-select-table-column prop="remark" label="备注"/>
          <el-table-column prop="goodsWeight" label="重量" :formatter="weightFormatter"/>
          <el-table-column label="操作" width="50px">
            <template slot-scope="scope">
              <div class="table-operator" v-if="!scope.row.isNew">
                <i class="el-icon-third-lajitong" @click="removeOrderDetailsList(scope.$index)"/>
              </div>
            </template>
          </el-table-column>
        </qx-select-table>
        <div class="total">
          <div><span>总重量：{{totalWeight}}</span></div>
          <div><span>总数量：{{totalQuantity}}</span></div>
        </div>
      </div>
    </div>
    <el-dialog title="销售订单选择" :visible.sync="dialog.orderVisible" width="80%" :close-on-click-modal="false">
      <sale-order-dialog v-if="dialog.orderVisible"
                         @close="closeOrderDialog"
                         @select="selectOrder"
                         :is-selected-order="qxList.value.orderDetailsList"
                         :goods-type="dataObj.goodsType"
                         :cust-name="dataObj.custName"
                         :user-name="dataObj.userName"
                         :unit-list="mainUnitList"
                         :orderOperatorId="dataObj.orderOperatorId"
                         :simpleType="dataObj.simpleType"/>
    </el-dialog>
    <el-drawer
      title="选择地址"
      :visible.sync="addressDrawervisible"
      direction="rtl"
      size="50%"
      class="address_drawer">
      <address-select-drawer :addressList="addressList"
                             :addressType="addressType"
                             :tableIndex="tableIndex"
                             @addressSelectClose="addressSelectClose"
                             @addressSelectSubmit="addressSelectSubmit"
                             @addAddressShow="addAddressShow"
                             ref="addressSelectDrawer"/>
    </el-drawer>
    <el-dialog
      title="新增地址"
      :visible.sync="addressAddVisible"
      width="50%"
      :show-close="false"
      :close-on-click-modal="false"
      center>
      <address-add-dialog @addAddressClose="addAddressClose"
                          @submitAddress="submitAddress"
                          :addressLists="addressLists"
                          :addressType="addressType"
                          v-if="addressAddVisible"
                          ref="addressAddDialog"/>
    </el-dialog>
  </div>
</template>

<script>
/**
 * @Description: 新增发货通知单
 * @Author: 菩萨蛮
 * @Date: 2020/9/24 10:37 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import moment from 'moment';
import noticeOrderMixin from '@/mixins/order/NoticeOrderMixin';
import NewOrder from '../../../mixins/order/common/NewOrder';
import NoticeOrder from '../../../bean/order/NoticeOrder';
import orderOperate from '../../../mixins/order/common/OrderOperate';
import lodash from "lodash";
import Settlement from '../../../components/order/Settlement';

export default {
  name: 'NewNoticeOrderMayang',
  qx: {
    pageType: 'new',
    order: NoticeOrder
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.initNoticeOrder();
    });
  },
  mixins: [orderOperate, NewOrder, noticeOrderMixin],
  components: { Settlement },
  data() {
    return {
      activeName: '基本信息',
      addressFlag: 0,
      defaultCustomer: ''
    }
  },
  mounted() {
    // this.getOrderOperator();
    this.dataObj.userName = '样品';
    this.dataObj.simpleType = '米样';
    this.dataObj.type = '1';
  },
  watch: {
    'qxList.value.orderDetailsList.length': {
      handler(newValue, oldValue) {
        if (oldValue === 0) {
          if (this.qxList.value.orderDetailsList[0].settlePlans) {
            this.settlePlans = JSON.parse(JSON.stringify(this.qxList.value.orderDetailsList[0].settlePlans));
          } else {
            this.settlePlans = JSON.parse(JSON.stringify(this.custSettlePlans));
          }
        }
      }
    }
  },
  methods: {
    async goSubmit(needAudit, data) {
      const { code } = await this.qPost({
        url: this.url,
        data: {
          ...data,
          baseInfoV: {
            ...data.baseInfoV,
            createSource: 'SCM'
          }
        }
      });

      if (code === 200) {
        this.$message.success('新增成功！');
        this.close(true);
      } else {
        this.submitDisable = false;
      }
    },
    checkValue:lodash.debounce(function () {
      this.submit();
    },3000,{
      'leading': true, //在延迟开始前立即调用事件
      'trailing': false, //在延时结束后不调用,保证事件只被触发一次
    }),
    async setDefaultSettlement() {
      if (this.dataObj.custName) {
        const {data} = await this.qGet(`/customer/info?custName=${this.dataObj.custName}`);
        if (data.datas.length > 0) {
          this.settlePlans = data.datas[0].settlePlans;
        }
      } else {
        this.settlePlans = [{
          ways: '',
          way: '',
          month: '0',
          day: 0,
          percent: '0'
        }]
      }
    },
    async initNoticeOrder() {
      this.dataObj.userName = '样品';
      if (this.$route.query && this.$route.query.goodsId) {
          this.goodsToNoticeObj = this.$route.query;
          this.dataObj.simpleType = '米样';
          return;
      }
      const noticeId = localStorage.getItem('noticeId');
      if (noticeId) {
        localStorage.removeItem('noticeId');
        await this.setDefaultValue(noticeId);
      }
    },
    async setDefaultValue(id) {
      const { data } = await this.qGet(`${this.url}/${id}`);
      const { data: custData } = await this.qGet(`customer/info?id=${data.baseInfoV.custId}`);
      if (!custData.datas || custData.datas.length === 0) {
        this.$message.error('该客户不存在或已禁用！');
        this.dataObj.goodsType = data.baseInfoV.goodsType;
        this.settlePlans = [{
          ways: '',
          way: '',
          month: '0',
          day: 0,
          percent: '0'
        }];
        return;
      }
      this.dataObj = {
        ...data,
        ...data.baseInfoV
      };
      if (custData.datas[0].settlePlans) {
        this.custSettlePlans = custData.datas[0].settlePlans;
      }
      // this.logistics = data.logistics;
      // this.qxList.value.orderDetailsList = data.orderList;
      // this.file = data.logistics.file;
      this.defaultCustomer = data.baseInfoV.custName;
      // this.dataObj.type = parseInt(this.dataObj.type);
      this.dataObj.id = '';
      // this.customerData = `${data.baseInfoV.custName}/${data.baseInfoV.contactName}/${data.baseInfoV.contactPhone}`;
      if (data.baseInfoV.address && data.baseInfoV.contactName) {
        if (data.baseInfoV.address.province) {
          this.deliveryAddress = `${data.baseInfoV.contactName} ${data.baseInfoV.contactPhone} ${data.baseInfoV.address.province}/${data.baseInfoV.address.city}/${data.baseInfoV.address.county}/${data.baseInfoV.address.street}/${data.baseInfoV.address.other}`;
        } else {
          this.deliveryAddress = `${data.baseInfoV.contactName} ${data.baseInfoV.contactPhone} ${data.baseInfoV.address.other}`;
        }
      }
      if (data.baseInfoV.billAddress && data.baseInfoV.billContactName) {
        if (data.baseInfoV.billAddress.province) {
          this.billAddress = `${data.baseInfoV.billContactName} ${data.baseInfoV.billContactPhone} ${data.baseInfoV.address.province}/${data.baseInfoV.address.city}/${data.baseInfoV.address.county}/${data.baseInfoV.address.street}/${data.baseInfoV.address.other}`;
        } else {
          this.billAddress = `${data.baseInfoV.billContactName} ${data.baseInfoV.billContactPhone} ${data.baseInfoV.address.other}`;
        }
        this.billIsShow = !(this.ifCompare(data.baseInfoV.billAddress, data.baseInfoV.address)
          && data.baseInfoV.billContactName == data.baseInfoV.contactName
          && data.baseInfoV.billContactPhone == data.baseInfoV.contactPhone);
      } else {
        this.billIsShow = false;
      }
      this.dataObj.deliveryTime = moment().format('yyyy-MM-DD');
      await this.getCustomer(data.baseInfoV.custClueId || data.baseInfoV.custLeadId);
      this.addressFlag ++;
    },
  }
};
</script>

<style lang="scss" scoped>
.total{
  font-size: 18px;
}
.transferInfo_input{
  width: 500px;
  ::v-deep .el-input__inner{
    height: 40px;
  }
}
::v-deep .el-drawer__header {
  margin-bottom: 0;
}
</style>
